import i18n from '../i18n/config';

/**
 * Utility function to check if a translation key exists in the current language
 * @param key The translation key to check
 * @param namespace The namespace to check in (optional)
 * @returns boolean indicating if the key exists
 */
export const translationKeyExists = (key: string, namespace?: string): boolean => {
  const ns = namespace || i18n.options.defaultNS;
  // Cast ns to string to satisfy TypeScript
  const exists = i18n.exists(key, { ns: ns as string });

  if (!exists && process.env.NODE_ENV === 'development') {
    console.warn(`Translation key not found: ${ns}:${key}`);
  }

  return exists;
};

/**
 * Utility function to validate all translation keys in a component
 * @param keys Array of translation keys to validate
 * @param namespace The namespace to check in (optional)
 * @returns Array of missing keys
 */
export const validateTranslationKeys = (keys: string[], namespace?: string): string[] => {
  const missingKeys: string[] = [];

  keys.forEach(key => {
    if (!translationKeyExists(key, namespace)) {
      missingKeys.push(key);
    }
  });

  return missingKeys;
};

/**
 * Utility function to ensure all required namespaces are loaded
 * @param namespaces Array of namespaces to ensure are loaded
 * @returns Promise that resolves when all namespaces are loaded
 */
export const ensureNamespacesLoaded = async (namespaces: string[]): Promise<void> => {
  await i18n.loadNamespaces(namespaces);
};
